<section class="reports-page">
  @if (loading) {
    <div class="reports-message">Loading report list...</div>
  }

  @if (error) {
    <div class="reports-message reports-message--error">{{ error }}</div>
  }

  @if (!loading && !error) {
    <div class="folder-list">
      @for (refinery of refineries; track refinery) {
        <div class="folder">
          <button class="folder__header" (click)="toggleFolder(refinery)">
            <span class="folder__arrow" [class.folder__arrow--expanded]="isFolderExpanded(refinery)">&#9654;</span>
            <span class="folder__name">{{ displayName(refinery) }}</span>
          </button>
          @if (isFolderExpanded(refinery)) {
            <div class="folder__content">
              @for (category of getCategories(refinery); track category) {
                <h3 class="category__title">{{ displayName(category) }}</h3>
                <div class="grid">
                  @for (report of getReports(refinery, category); track report) {
                    <a class="tile" [routerLink]="getReportLink(refinery, category, report)">
                      <span class="tile__name">{{ displayName(report) }}</span>
                    </a>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</section>
